<template>
    <div class="import-inbound-results-page">
        <base-header
            class="warehouse-main-page__header"
            :titulo="translate('messages.inbound_invoices_import_btn')"
            icon="el-icon-upload"
            :exibe-botao="false"
            :voltarPara="true"
        />
        <div class="view-container-wrapper">
            <div class="content">
                <el-form class="upload_section">
                    <div class="upload_card">
                        <div class="description">
                            <h3 class="description_text">
                                <span class="attention_marker">*</span>
                                <span> {{ translate('messages.inbound_invoices_import_main_text_first_row') }} </span>
                            </h3>
                            <ul class="description_list">
                                <li>{{ translate('messages.inbound_invoices_import_main_text_second_row') }}</li>
                                <li>{{ translate('messages.inbound_invoices_import_main_text_third_row') }}</li>
                                <li>{{ translate('messages.inbound_invoices_import_main_text_fourth_row') }}</li>
                            </ul>
                        </div>
                        <div class="upload_container">
                            <div class="upload_file_component">
                                <el-upload
                                    action="#"
                                    :auto-upload="false"
                                    :on-change="handleFileChange"
                                    :on-exceed="onExceed"
                                    :on-remove="handleFileRemove"
                                    :limit="1"
                                    :drag="true"
                                    ref="refImportarResultados"
                                >
                                    <i class="el-icon-upload"></i>
                                    <p class="el-upload__text">
                                        {{ translate('new_record.upload_text_first_row') }}
                                        <em>{{ translate('new_record.upload_text_second_row') }}</em>
                                    </p>
                                    <p>{{ translate('new_record.upload_text_third_row') }}</p>
                                </el-upload>
                            </div>
                        </div>
                        <el-button
                            class="upload-button"
                            size="mini"
                            type="primary"
                            :disabled="!selectedFile || isUploading"
                            :loading="isUploading"
                            @click="importar"
                        >
                            {{ translate('messages.inbound_invoices_import_btn') }}
                        </el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import TransferenciaTitularidadeService from '@/services/TransferenciaTitularidadeService';

export default {
    name: 'ImportInboundResultsPage',
    components: {
        BaseHeader
    },
    data() {
        return {
            selectedFile: null,
            isUploading: false
        };
    },
    methods: {
        translate(key, params = {}) {
            const base = 'warehouse';
            return this.$t(`${base}.${key}`, params);
        },
        handleFileChange(file) {
            this.selectedFile = file.raw;
        },
        handleFileRemove() {
            this.selectedFile = null;
        },
        onExceed() {
            this.$notify.warning({
                message: this.$t('mensagens.operacao.notificacao.uploadUnico'),
                position: 'top-left'
            });
        },
        importar() {
            if (!this.selectedFile) return;

            this.isUploading = true;
            return TransferenciaTitularidadeService.importarResultadosAprovacaoMassa(this.selectedFile)
                .then(() => {
                    this.$notify.success({
                        message: this.translate('messages.inbound_invoices_import_queued')
                    });
                    this.$router.push({ name: 'NotasEntrada' });
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.translate('messages.inbound_invoices_import_error')
                    });
                })
                .finally(() => {
                    this.isUploading = false;
                });
        }
    }
};
</script>

<style scoped lang="scss">
.import-inbound-results-page {
    .view-container-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px;
    }

    .upload_section {
        display: grid;
        grid-template-columns: 100%;
        gap: 16px;
        height: calc(100vh - 184px);

        .upload_card {
            padding: 16px;
            background: white;
            border-radius: 5px;
            display: flex;
            flex-direction: column;
            font-size: 14px;

            .description {
                .description_text {
                    font-weight: 500;
                }

                .attention_marker {
                    color: var(--danger);
                }

                .description_list {
                    margin: 8px 0 0 -15px;
                }
            }

            .upload_container {
                display: flex;
                width: 100%;
                gap: 16px;
                margin: 24px 0 0 0;

                .upload_file_component {
                    width: 100%;
                    height: 100%;
                    .el-upload__text {
                        height: 100%;
                    }
                }
            }

            .upload-button {
                padding: 10px 30px;
                margin: 24px 0 0 auto;
                align-self: end;
            }
        }
    }
}
.el-icon-upload {
    font-size: 40px;
    margin: 24px 0 16px;
}
</style>
